<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Project Member Participants</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form class="pa-5" v-if="!loading">
        <v-row>
          <v-col cols="10" md="10" sm="12">
            <v-label>Select members</v-label>
            <AutocompleteAvatar @changeData="changeMembers($event)" :storeLink="'member/getAllMembersBySearch'"
              :setectVale="form.members" :itemText="'name'"></AutocompleteAvatar>
          </v-col>
          <v-col cols="2" md="2" sm="12" class="mt-8">
            <v-label>&nbsp;</v-label>
            <v-btn large color="green" depressed :disabled="loading || !form.members" block @click="add()">Add</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <ParticipantsList :participants="participants" :project="project" @deleteParticipant="deleteParticipant($event)">
      </ParticipantsList>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="previous()">Previous</v-btn>
          </v-col>
          <v-col cols="12" md="6" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="submit()">Next</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="succesMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="clossSnackbar" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import ParticipantsList from "../create/child/ParticipantsList";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";
import AutocompleteAvatar from "@/components/shared/AutocompleteAvatar";

export default {
  name: "groupSetUpFrom",
  props: ["uuid"],
  components: { Alert, Snackbars, ParticipantsList, AutocompleteAvatar },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    form: {
      members: [],
    },
    participants: [],
    project: []
  }),

  mounted() {
    this.getParticipantList();
    this.getProjectInfo();
  },

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  methods: {
    submit() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 5, uuid: this.uuid } })
    },

    add() {
      if (this.uuid !== null) {

        let fd = new FormData();
        fd.append("project_id", this.uuid);

        this.form.members.forEach((member, key) => {
          fd.append("members[" + key + "]", member);
        });

        this.errors = null;
        ProjectService.createParticipant(fd)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.getParticipantList();
              this.reset();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    getProjectInfo() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getProjectInfo(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.project = response.data.data;

            }
          })
          .catch((error) => {
            this.loading = false;
            this.project = [];
            if (error.response) {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              this.errors = errorOutput;
            }
          });
      }
    },

    getParticipantList() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getParticipantList(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.participants = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.participants = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    deleteParticipant(uuid) {
      if (uuid !== null) {
        this.loading = true;
        ProjectService.deleteProjectParticipant(uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.status_code === 200) {
              this.getParticipantList();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    changeMembers(value) {
      console.log(value);
      this.form.members = value;
      console.log('ffgfg', this.form.members);
    },

    previous() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 3, uuid: this.uuid } })
    },

    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.members = null;
    },
  },
};
</script>
